// A numeric filter trigger and panel: Equals, Greater than, Less than or Between, committed 900ms after
// the last edit.

import React from 'react'
import PropTypes from 'prop-types'

import { FilterMenu } from './FilterMenu'
import { RangeEditor } from './RangeEditor'

export const NumericFilter = ({ column }) => (
  <FilterMenu column={column}>
    <RangeEditor column={column} type="numeric" />
  </FilterMenu>
)

NumericFilter.propTypes = {
  column: PropTypes.object.isRequired,
}
